import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class ShipmentItemService extends DataService {

  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri + '/frtpackageitems/byshipmentdetailandpackage?frtShipmentDetailsId=';

  // Function to get the Shipment Review list by shipmentType
  getShipmentItemListByPackageType(shipmentDetailsId: number, shipmentPackagesId: number): Observable<any> {
    console.log('shipmentDetailsId : ' + shipmentDetailsId + ' shipmentPackagesId : ' + shipmentPackagesId);
    const shipmentitemListUrl = this.baseURI + shipmentDetailsId + '&frtShipmentPackagesId=' + shipmentPackagesId;
    this.setUri(shipmentitemListUrl);
    return this.get();
  }

  deletePackageItem(x: number) {
    const deletePackageItemUrl = this.apiUri + '/frtpackageitems/removefrtpackageitems?frtPackageItemsId=' + x;
    console.log('deletePackageItemUrl is : ' + deletePackageItemUrl);
    return this.http
      .put(deletePackageItemUrl, x);
  }

  getItemMasterList() {
    const getItemMasterURL = this.apiUri + '/frtitemsmaster';
    console.log('getItemMasterURL is : ' + getItemMasterURL);
    this.setUri(getItemMasterURL);
    return this.get();
  }

  getItemTypes(itemNumber): Observable<any> {
    let params = new HttpParams();
    params = params.set('itemNumber', itemNumber);
    this.setUri(this.apiUri + '/frtitemsmaster/' + itemNumber + '/itemNumber');
    // return this.get({ params });
    return this.get();
  }

  getItemMaster(itemNumber): Observable<any> {
    this.setUri(this.apiUri + '/frtitemsmaster/' + itemNumber);
    return this.get();
  }


}
